var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8067 0.0660131L0.985115 9.51586C0.795193 9.61121 0.671795 9.80191 0.662654 10.0142C0.653513 10.2265 0.759959 10.4271 0.940974 10.5384L5.34941 13.2513V19.4141C5.34941 19.6662 5.5107 19.89 5.74988 19.9698C5.9891 20.0496 6.25242 19.9675 6.40383 19.7659L9.41672 15.7543L16.1747 19.913C16.3387 20.014 16.5419 20.0279 16.7181 19.9502C16.8944 19.8725 17.0212 19.7131 17.0573 19.5239L20.6504 0.699255C20.6516 0.693005 20.6527 0.686755 20.6537 0.680466C20.7306 0.205974 20.2328 -0.153518 19.8067 0.0660131ZM5.90461 12.2171L2.45035 10.0914L16.236 3.17L5.90461 12.2171ZM6.52117 17.6583V13.2348L16.2261 4.73629C16.0129 5.02008 6.775 17.3203 6.52117 17.6583ZM16.0654 18.4699L10.1234 14.8133L19.0259 2.95972L16.0654 18.4699Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.661865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send_mail.a4cb238bcbbdfcf024726c36bf168bd1.svg";
export { ForwardRef as ReactComponent };